import React from "react";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";

const AppModal = ({
  modalId,
  imgSrc,
  title,
  subTitle,
  content,
  show,
  onClose,
}) => {
  const modalClass = `modal fade appModal ${show ? "show" : ""}`;

  return (
    <div
      className={modalClass}
      id={modalId}
      tabIndex="-1"
      aria-labelledby={`${modalId}Label`}
      aria-hidden={!show}
      data-bs-backdrop="static" data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content ckldd">
          <button
            type="button"
            className="btn-close ckld"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div className="modal-body">
            <div className="mobile-area">
              <figure>
                <img
                    src={"https://cdn.newsepick.com/mobile.png"}
                    className="img-fluid" alt="Download on the App Store" />
              </figure>
            </div>
            <div className="mobile-detail-area">
              <figure>
                <a href="/">
                  <img
                    src={"https://cdn.newsepick.com/logoBrand-r.png"}
                    alt="Newsepick"
                    className="img-fluid model-logo"
                  />
                </a>
              </figure>

              <h2>{title}</h2>
              <h5>{subTitle}</h5>
              <p>{content}</p>
              <div className="slp">
                <p className="modal-pref">Customize your preferences.</p>
                <h4 className="modal-news-content">Your News Your Pick!</h4>

                <div className="dlbtn-box">
                  <figure>
                      <Link to={"https://apps.apple.com/us/app/newsepick/id6473382773"} target="_blank" aria-label="Download on the App Store">
                          <LazyLoadImage
                              effect="blur"
                              src={"https://cdn.newsepick.com/apple-btn.png"}
                              //onError={(e)=>{e.target.onerror = null; e.target.src="https://cdn.newsepick.com/apple-btn.png"}}
                              className="img-fluid" alt="Download on the App Store" />
                      </Link>
                  </figure>
                  <figure>
                      <Link to={"https://play.google.com/store/apps/details?id=com.wse.newsepick"} target="_blank" aria-label="Get it on Google Play">
                          <LazyLoadImage
                              effect="blur"
                              src={"https://cdn.newsepick.com/googleplay-btn.png"}
                              //onError={(e)=>{e.target.onerror = null; e.target.src="https://cdn.newsepick.com/googleplay-btn.png"}}
                              className="img-fluid" alt="Get it on Google Play" />
                      </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { AppModal };
